import React from 'react';
import Icon from './Icon';

const BoundaryIcon = (props) => (
    <Icon {...props} viewBox="0 0 512 512">
        <rect width="32" height="32" x="440" y="440" fill="currentColor" />
        <rect width="33.455" height="32" x="306.182" y="440" fill="currentColor" />
        <rect width="33.455" height="32" x="172.364" y="440" fill="currentColor" />
        <rect width="33.455" height="32" x="373.091" y="440" fill="currentColor" />
        <rect width="33.455" height="32" x="105.455" y="440" fill="currentColor" />
        <path d="M472,40H56A16,16,0,0,0,40,56V472H72V72H472Z" fill="currentColor" />
        <rect width="32" height="33.454" x="440" y="373.091" fill="currentColor" />
        <rect width="32" height="33.454" x="440" y="306.182" fill="currentColor" />
        <rect width="32" height="33.454" x="440" y="105.454" fill="currentColor" />
        <rect width="32" height="33.454" x="440" y="172.363" fill="currentColor" />
        <rect width="32" height="33.455" x="440" y="239.272" fill="currentColor" />
        <rect width="33.455" height="32" x="239.272" y="440" fill="currentColor" />
    </Icon>
);

export default BoundaryIcon;